import {FullFillBox} from "common/FullFillBox"
import {useFindAllRealDevice} from "hooks/queries/real-device.query"
import {observer} from "mobx-react"
import {WheelchairListItems} from "pages/dashboard/wheelchair/WheelchairListItems"
import Skeleton from "react-loading-skeleton"
import {useRootStore} from "store/useRootStore"
import {filterDevice} from "pages/dashboard/Dashboard"

export const WheelchairList = observer(() => {
    const {data: result} = useFindAllRealDevice()
    const {dashboardStore: {deviceStatusFilterCondition, searchKeyword, deviceStatusCategory}} = useRootStore()
    let devices = result || []
    // if (deviceStatusFilterCondition) {
    //     devices = devices.filter(dev => deviceStatusFilterCondition.some(stat => dev.communicationDevice.status === stat))
    // }
    devices = filterDevice(deviceStatusCategory, devices)

    if (searchKeyword) {
        devices = devices.filter(dev => (dev.name.includes(searchKeyword) || dev.communicationDevice.eui.includes(searchKeyword)))
    }
    devices = devices.sort((a, b) => {
        return a.name > b.name ? 1 : -1
    })
    if (devices.length === 0) {
        return (
            <div className="box-list " style={{padding: 12}}>
                <div className="columns">
                    <div className="column is-one-third" style={{position: 'relative'}}>
                        <Skeleton count={1} height={160} className="has-background-grey-lighter"
                                  style={{opacity: .8}}
                                  enableAnimation={false}
                        />
                        <FullFillBox padding="30px">
                            등록된 장치가 없습니다
                        </FullFillBox>
                    </div>
                    <div className="column">
                        <Skeleton count={5} height={30} className="has-background-grey-lighter"
                                  style={{opacity: .8}}

                                  enableAnimation={false}
                        />
                    </div>
                </div>

            </div>
        );
    }
    return (
        <div className="box-list">
            <WheelchairListItems devices={devices}/>
        </div>
    );
})

